import { supabase } from "../../supabaseClient";

/**
 * Clean up answer values so numeric inputs convert from strings to Numbers.
 */
function sanitizeAnswers(answers) {
  const sanitized = {};
  for (const [key, value] of Object.entries(answers || {})) {
    // Convert numeric strings to actual numbers
    if (typeof value === "string" && value.trim() !== "" && !isNaN(Number(value))) {
      sanitized[key] = Number(value);
    } else {
      sanitized[key] = value;
    }
  }
  return sanitized;
}

export async function submitApplication(updateId, vendorId, answers) {
  const { data } = await supabase.auth.getSession();
  const session = data && data.session;
  if (!session) throw new Error("Please log in again.");

  const cleanAnswers = sanitizeAnswers(answers);

  const res = await fetch("/api/submit-application", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + session.access_token,
    },
    body: JSON.stringify({
      update_id: updateId,
      updateId: updateId,
      vendor_id: vendorId,
      vendorId: vendorId,
      answers: cleanAnswers,
    }),
  });

  if (res.ok) {
    try {
      return await res.json();
    } catch (e) {
      return { created_at: new Date().toISOString() };
    }
  }

  let message = "We couldn't send your application. Please try again.";
  try {
    const body = await res.json();
    if (body && body.error) message = body.error;
  } catch (e) {
    // keep fallback message
  }
  throw new Error(message);
}